import { inject, Component, Inject, TemplateRef, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, QueryList, signal, computed, ViewChildren, ElementRef } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn, Types } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { Geraete} from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { StatusModel } from "../../../Api/DcoApi/Status/StatusModel";
import { PGFilterService } from "../../Services/PGFilterService";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { AktePopup } from "./AktePopup";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import { VNRStatus } from "./VNRStatus";
import { ExportPopup } from "./ExportPopup";
import { StatusPipe } from "../../../Pipes/StatusPipe";
import { EmailDialog } from "../Versand/EmailDialog";
import {VersandService} from '../../Services/VersandService';
import {VersandStepper} from '../../../Componente/versand-stepper/versand-stepper';
import {IsWelcomeCallDirective} from '../../../Admin/AdminGuard';
import {PhoneCall} from '../../../Componente/PhoneCall';
import {NotificationService} from '../../../Services/NotificationService';
import {DhlControlls} from '../Versand/Controlls/dhl-controlls/dhl-controlls';


@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn, PhoneCall,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent, StatusPipe, VersandStepper, DhlControlls
  ],
  selector: 'StatusView',
  templateUrl: './StatusView.html',
  standalone: true,
  styleUrl: './StatusView.css'
})
export class StatusView implements OnChanges, AfterViewInit {
  @ViewChild('Grid') childComponent!: DataGridView<StatusModel>;
  @Input() Status: number = 0;
  toastService: ToastService;

  private modalService = inject(NgbModal);

  selectedIDs: number[] = [];

  dataurl = computed(() => { return `/Backend/Api/V2/Status/List/${this.Status ?? -1}/${this.pgService.PG()}` })
  constructor(public pgService: PGFilterService) {
    this.toastService = inject(ToastService)

  }
  ngAfterViewInit(): void {
    this.loadColumns();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["Status"]) {
      this.loadColumns();
    }
  }

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }

  loadColumns() {
    var columns = [new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>)]

    const switchCase = Math.trunc(this.Status / 10);

    var buttonTemplate = this.buttonTemplate;

    // 1. HAUPT-LOGIK: Der Switch-Block
    switch (switchCase) {
      case 0:
      case 1:
        if (this.Status == 15) {
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'zuzahlungErhalten',
            header: 'Zuzahlung Erhalten',
            cellClass: (data: StatusModel, field: any) => ''
         , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
        }
        break;

      case 2:
        // UseFreeConfig = true; (Logik-Flag aus C#)

        if (this.Status == 21) {
          this.pushStandardUserColumns(columns);
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'ruecklauferAm', header: 'eKV Rückläufer',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragEkvRuecklauferGrund', header: 'Grund',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        }
        else if (this.Status == 26) {
          buttonTemplate = this.buttonTemplateCall;
          this.pushStandardUserColumns(columns);
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragGenehmigungKasse', header: 'Kasse genehmigt',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy' } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userPhoneNumber', header: 'Handy/Telefonnummer', cellTemplate: this.Phone,
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragLetzterVersuchWelcomeCall',
            header: 'LastCall',

            cellClass: (data: StatusModel, field: any) => '', DataType: Types.Date, formart: 'dd.MM.yyyy'
         , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragAnzahlVersucheWelcomeCall', header: 'Counter',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Number
          } as DataGridViewCollumn<StatusModel>));

          // Hinweis: Der "WellcomeCall"-Button fiele hier in die Button-Logik des Grids
        }
        else if (this.Status == 20) {

          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userFirstName', header: 'Kunde Vorname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userLastName', header: 'Kunde Nachname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'versicherungsId', header: 'Versichertennummer',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));

            columns.push(new DataGridViewCollumn<StatusModel>().setValues({
              field: 'krankenkasseName', header: 'Krankenkasse',
              cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'antragVersandAm', header: 'eKV Antrag Versand',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'kooperationspartnerName', header: 'Kooperationspartner',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));

          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragBemerkungen', header: 'Bemerkungen',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        }
        else {
          this.pushStandardUserColumns(columns);
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragBemerkungen', header: 'Bemerkungen',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        }
        break;

      case 3:

        buttonTemplate = this.buttonTemplateLeitstelle;
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'userFirstName', header: 'Kunde Vorname',
          cellClass: (data: StatusModel, field: any) => '', DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'userLastName', header: 'Kunde Nachname',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'geraetId', header: 'Geräte ID',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'kooperationspartnerName', header: 'Kooperationspartner',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'leitstelleName', header: 'Leitstelle',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragWelcomeCall', header: 'Welcomecall',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy' } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'versicherungsId', header: 'Versichertennummer',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragAsbBeauftragtAm', header: 'LST beauftragt',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
        /* columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragAsbBestaetigtAm', header: 'LST bestätigt',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, cellTemplate: this.LeitstelleDate, DataType: Types.Date, formart: 'dd.MM.yyyy'
        } as DataGridViewCollumn<StatusModel>));*/
        break;

      case 4:

        if (User.HatVolleBerechtigung) {
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'key',
            header: 'Zu Versenden', // Im C#-Code war hier der "Alle Auswählen"-Button im Header
            cellClass: (data: StatusModel, field: any) => '', cellTemplate: this.VersandCheck, headerTemplate: this.VersandCheckCaption
            , AllowOrder: false, AllowSearch: false
          } as DataGridViewCollumn<StatusModel>));
        }
        buttonTemplate = this.VersandBtn;

        this.pushStandardUserColumns(columns, false); // Ohne Krankenkasse im Admin-Zweig des Case 4 laut C#-Code
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'versicherungsId', header: 'Versichertennummer',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'leitstelleName', header: 'Leitstelle',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'geraetId', header: 'Geräte-ID',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragVersandAm', header: 'Versand',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy' } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragGeliefertAm', header: 'Geliefert',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, cellTemplate: this.VersandDate, DataType: Types.Date, formart: 'dd.MM.yyyy'
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'versandTracking', header: 'Versand Status',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: false, AllowSearch: false, DataType: Types.String, cellTemplate: this.TrackingStatus } as DataGridViewCollumn<StatusModel>));
        //TrackingStatus
        break;

      case 5:
        if (this.Status == 55) {

          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userFirstName', header: 'Kunde Vorname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userLastName', header: 'Kunde Nachname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'versicherungsId', header: 'Versichertennummer',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'kooperationspartnerName', header: 'Kooperationspartner',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragInbetriebnahmeAm', header: 'INBR Datum',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy' } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragIbn',
            header: 'INBR Vorhanden',
            cellClass: (data: StatusModel, field: any) => '', cellTemplate: this.INBRVorhanden, DataType: Types.Date, formart: 'dd.MM.yyyy'
         , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
        } else {
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userFirstName', header: 'Kunde Vorname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userLastName', header: 'Kunde Nachname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'versicherungsId', header: 'Versichertennummer',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
          } as DataGridViewCollumn<StatusModel>));
            columns.push(new DataGridViewCollumn<StatusModel>().setValues({
              field: 'krankenkasseName', header: 'Krankenkasse',
              cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
            } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'geraetId', header: 'Geräte-ID',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'createdAt', header: 'Angelegt Am',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'kooperationspartnerName', header: 'Kooperationspartner',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragGeliefertAm', header: 'Geliefert',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'status', header: 'Status',
            cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), DataType: Types.Number, pipe: StatusPipe
            , AllowOrder: true, AllowSearch: true
          } as DataGridViewCollumn<StatusModel>));

        }
        break;

      case 20: // Entspricht Status-Werten von 200 bis 209
        // UseFreeConfig = true;
        if (this.Status === 26) { // C#-Logik prüfte hier explizit im 20er Case auf 26 (also Status 260 oder Ähnliches)
          this.pushStandardUserColumns(columns);
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragGenehmigtAm', header: 'GenehmigtAm - eKV Datum',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragAssignedUser', header: 'LE-Agent',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragGenehmigungKasse', header: 'Kasse genehmigt',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy' } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragInAbrechnung', header: 'In Abrechnung',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
        } else {
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userFirstName', header: 'Kunde Vorname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'userLastName', header: 'Kunde Nachname',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
          } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'versicherungsId', header: 'Versichertennummer',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
              field: 'krankenkasseName', header: 'Krankenkasse',
              cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'geraetId', header: 'Geräte ID',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'kooperationspartnerName', header: 'Kooperationspartner',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragAssignedUser', header: 'User',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));

          columns.push(new DataGridViewCollumn<StatusModel>().setValues({
            field: 'vertragInbetriebnahmeAm', header: 'In Abrechnung',
            cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
        }
        break;

      case 80:
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragRueckholungEinfordern', // Berechnetes Feld im C#-Code (Mahnstufe 0-3)
          header: 'Mahnstufe',
          cellClass: (data: StatusModel, field: any) => '', DataType: Types.Number
       , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'geraetId', header: 'Geräte-ID',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        break;

      case 90:
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'kooperationspartnerName', header: 'Kooperationspartner',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'userFirstName', header: 'Kunde Vorname',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'userLastName', header: 'Kunde Nachname',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'versicherungsId', header: 'Versichertennummer',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'krankenkasseName', header: 'Krankenkasse',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'status', header: 'Status',
          cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), AllowOrder: true, AllowSearch: true, DataType: Types.Number, pipe: StatusPipe
        } as DataGridViewCollumn<StatusModel>));//vertragAbgelehnt
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragAbgelehnt', header: 'Abgeleht Am',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'grundBezeichnung', header: 'eKV Abgelehnt Grund',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>)); // Nutzt Fallback-Logik aus dem Select
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragAssignedUser', header: 'LE-Agent',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragAssignedCCAgent', header: 'CC-Agent',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
        } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragWiderrufGrund', header: 'Widerruf Grund',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'vertragRuecklauferGrund', header: 'Rückholung Grund',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
        } as DataGridViewCollumn<StatusModel>));
        break;
    }

    // 2. NACHGELAGERTE LOGIK: Überschreibende if-Blöcke außerhalb des Switch

    if( this.Status == -2)
    {
      buttonTemplate = this.buttonTemplateQCCall;

      columns.length = 0;
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'pflegegruppe',
        header: 'PG',

        cellClass: (data: StatusModel, field: any) => `PG${data.pflegegruppe}`, DataType: Types.Number
        , AllowOrder: true, AllowSearch: true
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'userPhoneNumber', header: 'Handy/Telefonnummer', cellTemplate: this.Phone,
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<StatusModel>));
      this.pushStandardUserColumns(columns);

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'anzahlCallQC', header: 'Anzahl Anrufe',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Number } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'lastCallQC', header: 'Letzter Anruf',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'createdAt', header: 'Angelegt Am',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
      } as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'status', header: 'Status',
        cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), AllowOrder: true, AllowSearch: true, DataType: Types.Number, pipe: StatusPipe
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragAssignedUser', header: 'LE-Agent',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragAssignedCCAgent', header: 'CC-Agent',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<StatusModel>));
    }

    if (!this.Status || this.Status == -1 ) {
      columns.length = 0;
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'pflegegruppe',
        header: 'PG',

        cellClass: (data: StatusModel, field: any) => `PG${data.pflegegruppe}`, DataType: Types.Number
        , AllowOrder: true, AllowSearch: true
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'userPhoneNumber', header: 'Handy/Telefonnummer', cellTemplate: this.Phone,
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'userFirstName', header: 'Kunde Vorname',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'userLastName', header: 'Kunde Nachname',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'birthDay', header: 'Gebutstag',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'versicherungsId', header: 'Versichertennummer',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));

        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'krankenkasseName', header: 'Krankenkasse',
          cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'kooperationspartnerName', header: 'Kooperationspartner',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetId', header: 'Geräte-ID',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetSeriennummer', header: 'Seriennummer',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'createdAt', header: 'Angelegt Am',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'status', header: 'Status',
        cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), AllowOrder: true, AllowSearch: true, DataType: Types.Number, pipe: StatusPipe
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragAssignedUser', header: 'LE-Agent',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragAssignedCCAgent', header: 'CC-Agent',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<StatusModel>));
    }

    if (this.Status >= 800 && this.Status < 900) {
      columns.length = 0;
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      if (User.HatVolleBerechtigung) {
        columns.push(new DataGridViewCollumn<StatusModel>().setValues({
          field: 'key',
          header: 'Zu Versenden', // Im C#-Code war hier der "Alle Auswählen"-Button im Header
          cellClass: (data: StatusModel, field: any) => '', cellTemplate: this.VersandCheck, headerTemplate: this.VersandCheckCaption
          , AllowOrder: false, AllowSearch: false
        } as DataGridViewCollumn<StatusModel>));
      }

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'userFirstName', header: 'Kunde Vorname',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'userLastName', header: 'Kunde Nachname',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'userPhoneNumber', header: 'Handy/Telefonnummer', cellTemplate: this.Phone,
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'versicherungsId', header: 'Versichertennummer',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetId', header: 'Geräte-ID',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragRueckholung', header: 'Rückholung',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragRueckholungBeauftragt', header: 'Beauftragt',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy' } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragRueckholungEinfordern', header: 'Betrag Einfordern',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy' } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragRueckholungMahnung', header: 'Mahnung',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragRueckholungMahnung2', header: 'Mahnung 2',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragAsbAbgemeldet', header: 'LST Abgemeldet',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragRueckholungGeliefert', header: 'Geliefert',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragRueckholungAbgeschlossen', header: 'Abgeschlossen',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
      } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'retourenTracking', header: 'Versand Status',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: false, AllowSearch: false, DataType: Types.String, cellTemplate: this.TrackingStatus } as DataGridViewCollumn<StatusModel>));
      buttonTemplate = this.RetoureBtn;
    }

    if (this.Status == -999) {
      buttonTemplate = this.buttonTemplateIK;
      columns.length = 0;
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'pflegegruppe',
        header: 'PG',

        cellClass: (data: StatusModel, field: any) => `PG${data.pflegegruppe}`, DataType: Types.Number
     , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      this.pushStandardUserColumns(columns);
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetId', header: 'Geräte-ID',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetSeriennummer', header: 'Seriennummer',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'createdAt', header: 'Angelegt Am',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'status', header: 'Status',
        cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), AllowOrder: true, AllowSearch: true, DataType: Types.String, pipe: StatusPipe } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'vertragAssignedUser', header: 'LE-Agent',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
      // Hinweis: Der Popup-Button für EkvNrActionResult wird hier über das Button-Modell gesteuert
    }

    if (this.Status == 0) {
      columns.length = 0;
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      this.pushStandardUserColumns(columns);
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetId', header: 'Geräte-ID',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'createdAt', header: 'Angelegt Am',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
} as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'status', header: 'Status',
        cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), AllowOrder: true, AllowSearch: true, DataType: Types.Number, pipe: StatusPipe } as DataGridViewCollumn<StatusModel>));
    }

    if (this.Status == 999) {
      columns.length = 0;
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'pflegegruppe',
        header: 'PG',

        cellClass: (data: StatusModel, field: any) => `PG${data.pflegegruppe}`, DataType: Types.Number
        , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      this.pushStandardUserColumns(columns);
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetId', header: 'Geräte-ID',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'createdAt', header: 'Angelegt Am',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date, formart: 'dd.MM.yyyy'
      } as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'status', header: 'Status',
        cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), AllowOrder: true, AllowSearch: true, DataType: Types.Number, pipe: StatusPipe } as DataGridViewCollumn<StatusModel>));
    }


    if (this.Status == 1) {
      columns.length = 0;
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      this.pushStandardUserColumns(columns);
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'geraetId', header: 'Geräte-ID',
        cellClass: (data: StatusModel, field: any) => '', DataType: Types.String
     , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'createdAt', header: 'Angelegt Am',
        cellClass: (data: StatusModel, field: any) => '', DataType: Types.Date, formart: 'dd.MM.yyyy'
     , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'status', header: 'Status',
        cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), DataType: Types.Number, pipe: StatusPipe
     , AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>));
    }

    columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', header: '', cellTemplate: buttonTemplate, isFixed: true, AllowSearch: false, AllowOrder: false, cellClass: (data: StatusModel, field: any) => { return ""; } } as DataGridViewCollumn<StatusModel>))
    if (this.childComponent) {
      this.childComponent.columns.reset(columns);
      this.childComponent.columns.notifyOnChanges();
    }
  }

  OpenAkte(row: StatusModel) {
    var modal = this.modalService.open(AktePopup)
    modal.componentInstance.Key = row.key;
    modal.componentInstance.versichertenNr = row.versicherungsId;
    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }

  statusClass(status: number): string {

    switch (status) {
      case 20:
      case 21:
        return "SYelow";
      case 26:
      case 30:
      case 31:
      case 40:
      case 42:
      case 51:
        return "Lime";
      case 55:
        return 'SOrange';
      case 200:
        return 'SGreen';
      case 800:
      case 801:
      case 802:
      case 803:
      case 804:
      case 805:
      case 806:
      case 807:
      case 808:
      case 809:
      case 810:
        return 'SBloue';
      case -26:
        return 'SLBloue';
      case 900:
      case 901:
      case 902:
        return 'SRed';
    }

    return '';
  }

  OpenUserAuftraege(row: StatusModel) {
    var modal = this.modalService.open(VNRStatus)
    modal.componentInstance.versichertenNr = row.versicherungsId;
    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }
  @ViewChildren('VersandCbx') checkboxElements!: QueryList<ElementRef<HTMLInputElement>>;
  @ViewChild('TrackingStatus') TrackingStatus!: TemplateRef<any>;

  SelectAll() {
    this.checkboxElements.forEach((checkboxRef: ElementRef<HTMLInputElement>) => {
      const checkbox = checkboxRef.nativeElement;

      // 3. Only target them if they match your specific class
      if (checkbox.classList.contains('VersandCbx')) {

        // Force the check state to true if it isn't already
        if (!checkbox.checked) {
          checkbox.checked = true;

          // 4. CRITICAL: Manually dispatch the change event
          // This forces Angular to run your (change)="onCheckboxChange(...)" function!
          checkbox.dispatchEvent(new Event('change'));
        }
      }
    });
  }

  OpenAkteNew() {
    var modal = this.modalService.open(AktePopup)
    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }

  pushStandardUserColumns(columns: DataGridViewCollumn<StatusModel>[], includeKrankenkasse: boolean = true) {
    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'userFirstName', header: 'Kunde Vorname',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'userLastName', header: 'Kunde Nachname',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
} as DataGridViewCollumn<StatusModel>));
    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'versicherungsId', header: 'Versichertennummer',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
  if (includeKrankenkasse) {
    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'krankenkasseName', header: 'Krankenkasse',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
  }
    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'kooperationspartnerName', header: 'Kooperationspartner',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String } as DataGridViewCollumn<StatusModel>));
}

  @ViewChild('buttonTemplate') buttonTemplate!: TemplateRef<any>;

  @ViewChild('buttonTemplateIK') buttonTemplateIK!: TemplateRef<any>;
  @ViewChild('buttonTemplateCall') buttonTemplateCall!: TemplateRef<any>;
  @ViewChild('buttonTemplateLeitstelle') buttonTemplateLeitstelle!: TemplateRef<any>;
  @ViewChild('LeitstelleDate') LeitstelleDate!: TemplateRef<any>;
  @ViewChild('buttonTemplateVersand') buttonTemplateVersand!: TemplateRef<any>;
  @ViewChild('VersandCheck') VersandCheck!: TemplateRef<any>;
  @ViewChild('VersandCheckCaption') VersandCheckCaption!: TemplateRef<any>;
  @ViewChild('VersandDate') VersandDate!: TemplateRef<any>;
  @ViewChild('INBRVorhanden') INBRVorhanden!: TemplateRef<any>;
  @ViewChild('VersandBtn') VersandBtn!: TemplateRef<any>;
  @ViewChild('RetoureBtn') RetoureBtn !: TemplateRef<any>;
  @ViewChild('Phone') Phone !: TemplateRef<any>;
  @ViewChild('buttonTemplateQCCall') buttonTemplateQCCall !: TemplateRef<any>;

  Client: RestClient = new RestClient();

  Caption() {
    var HeaderText = '';
    var Status = this.Status ?? -1;
    switch (Math.trunc(Status / 10)) {
      case 0:
        HeaderText = "Neu";
        break;
      case 1:
        HeaderText = "Zuzahlungspflichtig";
        break;
      case 2:
        HeaderText = "eKV";
        break;
      case 3:
        HeaderText = "Leitstelle";
        break;
      case 4:
        HeaderText = "Versand";
        break;
      case 5:
        HeaderText = "INBR";
        break;
      case 20:
        HeaderText = "In Betrieb";
        break;
      case 80:
        HeaderText = "Rückholung";
        break;
      case 90:
        HeaderText = "Beendet / Abgelehnt";
        break;
    }
    if (Status == 999) {
      HeaderText = "Archive";
    }
    if (Status == 15) {
      HeaderText = "Zuzahlung erhalten";
    }
    if (Status == 21) {
      HeaderText = "eKV Rückläufer";
    }

    if (Status == 25) {
      HeaderText = "eKV Klärung";
    }

    if (Status == 26) {
      HeaderText = "Wellcome Call";
    }

    if (Status == 1) {
      HeaderText = "Postversand";
    }

    if (Status == -1) {
      HeaderText = "Gesamtübersicht";
    }

    if (Status == -2) {
      HeaderText = "QC / Leads";
    }

    if (Status == -999) {
      HeaderText = "In Klärung";
    }

    if (Status == 55) {
      HeaderText = "Unterschrift wartend";
    }

    return HeaderText;
  }

  async SendAndReloadGet(url: string) {
    await this.Client.Get(url);
    this.triggerReload();


  }

  getJsonString(date: any) {

    const formatter = new Intl.DateTimeFormat('en-US', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
    return formatter.format(date).replace(/\//g, '.');
    return JSON.stringify(date).replace(/"/g, '').split('T')[0];
  }

  async Export(versand: boolean = true) {
    await this.VersandService.DownloadMultiPart(`/Backend/Api/V2/VersandAuftraege/MassSendBySelection/File`, this.selectedIDs, versand);
    this.selectedIDs = [];
    this.triggerReload();
  }
  VersandService : VersandService = inject(VersandService);






  addOrRemoveID(key: number) {
    var entry = this.selectedIDs.find(o => o == key);

    if (entry) {
      this.selectedIDs = this.selectedIDs.filter(o => o != key)
    }
    else {
      this.selectedIDs.push(key);
    }
  }

  OpenPartnerExport() {
    var modal = this.modalService.open(ExportPopup)

    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }
}
